module.exports = __webpack_public_path__ + "./ten-year_9ce4bfc9115c9c8c58a2b3789bc06f44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ten-year.jpg
// module id = 637
// module chunks = 0